var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseSession = function SvgCloseSession(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4518_20215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 29.9999H5.11111C4.28599 29.9999 3.49467 29.6722 2.91122 29.0887C2.32778 28.5053 2 27.714 2 26.8888V5.11111C2 4.28599 2.32778 3.49467 2.91122 2.91122C3.49467 2.32778 4.28599 2 5.11111 2H11.3333M22.2222 23.7779L30 16.0002M30 16.0002L22.2222 8.2224M30 16.0002L11.3333 16",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4518_20215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  })))));
};
export default SvgCloseSession;